<template>
  <FloatingPillButton variant="primary" @click="handleClick" class="absolute top-4 z-20 generate-widget">
    <template #start>
      <AiBackgroundIcon />
    </template>
    <template #center>
      {{ I18n.t("editor.magic_background.variants.variant_a.create_ai_scene") }}
    </template>
  </FloatingPillButton>
</template>

<script setup lang="ts">
import { FloatingPillButton, AiBackgroundIcon } from "prism";
import { useEditorStore } from "@/stores/editor_store";
import { inject } from "vue";

const I18n = inject("I18n");
import { rbgMbWidgetClickedV100 } from "kaleido-event-tracker";

const editorStore = useEditorStore();

const handleClick = () => {
  rbgMbWidgetClickedV100({ image_id: editorStore.selectedImage.meta.id });
  editorStore.openedBackgroundTab = "ai_scene";
  editorStore.openedPanel = "addBackground";
};
</script>

<style scoped>
.generate-widget {
  left: 50%;
  transform: translateX(-50%);
}
</style>
